const DashboardPlotTypeEnum = {
  BAR_CHART_PCT        : 'BarPercentagePlot',
  BAR_CHART            : 'BarPlot',
  BAR_CHART_HISTOGRAM  : 'HistPlot',
  FORWARD_LOOKING_CHART: 'PathsPlot',
  PIE_CHART            : 'PiePlot'
}
export default DashboardPlotTypeEnum
